import { apiClient } from '../../../utils/axios';
import { useDispatch } from 'react-redux';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';

const authorizeShopifyHandler = async (query) => {
  const { data } = await apiClient.patch(
    `shopify-oauth/authorize`,
    {
      shopId: query.shopId,
      authorizationCode: query.authorizationCode,
      orderEvent: query.orderEvent,
    },
    {
      headers: { Authorization: `Bearer ${query.token}` },
    },
  );
  return data;
};

export const useAuthorizeShopifyHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const mutation = useMutation({
    mutationFn: authorizeShopifyHandler,
    onSuccess: (data, variables, context) => {
      dispatch(showSnackbar({ message: 'Shopify authorized successfully!', severity: 'success' }));
      queryClient.invalidateQueries({ queryKey: ['authorize-shopify'] });
      onSuccess && onSuccess(variables);
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        if (error.response.status === 400) {
          setError(error.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: error.response.data, severity: 'error' }));
      }
      dispatch(showSnackbar({ message: error, severity: 'error' }));
    },
  });

  const onSubmit = async (data) => {
    mutation.mutate({ ...data });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit: onSubmit,
  };
};
